<template>
  <div class="projectDetail">
    <projectInfo :project="listDetail" :projectId="$route.query.projectId" v-if="tenderFlag === 2" :typeText="'你已投标'"/>
    <projectInfo :project="listDetail" :projectId="$route.query.projectId" v-else/>

  </div>
</template>

<script>
import {getNormalProjectInfo, getProjectTenderFlag} from '@api/getJob'
import projectInfo from '@/components/projectInfo'

export default {
  name: 'projectDetail',
  components: {
    projectInfo
  },
  data() {
    return {
      listDetail: {},
      tenderFlag: '', // 投标状态：0-未报名；1-已报名未投标；2-已投标
      signFlag: '',
      show: false
    }
  },
  created() {
    this.getProjectTender()
    this.getProjectInfo()
  },
  methods: {
    getProjectTender() {
      getProjectTenderFlag({
        projectId: this.$route.query.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.tenderFlag = res.data.data.tenderFlag
          this.signFlag = res.data.data.signFlag
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    getProjectInfo() {
      getNormalProjectInfo({
        id: this.$route.query.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.listDetail = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.projectDetail {
  padding: 15px 0;
  padding-bottom: 60px;

  .basic {
    .title {
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    .textTitle {
      font-size: 20px;
      line-height: 22px;
      font-weight: 600;
    }

    .text {
      font-size: 20px;
      margin-bottom: 10px;
    }
  }

  .btn-div {
    width: 60%;
    margin: 0 auto;
    margin-top: 25px;
  }

  .hasBid {
    background-color: #fff;
    padding: 15px 25px;
    color: #F2B72D;
    font-size: 22px;
    font-weight: 500;
    margin-top: 15px;
    margin-bottom: 15px;
    border-radius: 5px;
  }
}
</style>
